import React, { FC } from 'react';
import '../style/chart_container.scss';
import { Juridiction } from '../../entity.types';

type Props = {
  juridictions: Array<Juridiction>;
  children: (data: {
    sortedJuridictions: Array<Juridiction>;
  }) => React.ReactNode;
};

export const JuridictionsChartContainer: FC<Props> = ({
  children,
  juridictions,
}) => {
  const sortedJuridictions = juridictions.sort((j1, j2) => j2.count - j1.count);

  return (
    <div className="chart-container">{children({ sortedJuridictions })}</div>
  );
};
